import CollapsableTagView from "../UI/CollapsableTagView";
import { FaList } from "react-icons/fa";

const IdoDetailCard = ({ idoDetailArray = [] }) => {
    const itemRenderer = (item, i) => {
        return (
            <div
                key={i}
                className={`rounded-lg flex flex-col items-center bg-kadItemDarkBg py-3 ${
                    item.colspan || ""
                }`}
            >
                <span className="text-kad-gradient size-sm">{item.cap}</span>
                <span> {item.name}</span>
                <span className="size-sm font-normal">{item.value}</span>
            </div>
        );
    };
    return (
        <CollapsableTagView
            icon={<FaList />}
            tagHeader="IDO Details"
            tagList={idoDetailArray}
            itemRenderer={itemRenderer}
        />
    );
};
export default IdoDetailCard;
